import Drawer from "../../common/Drawer";

/**
 * Initializes the open booking form date feature.
 * When "Book now" buttons are clicked, the booking form date is opened.
 *
 * @return {undefined} This function does not return a value.
 */
const initOpenBookingFormDate = () => {
  const openBookingFormDateButtons = document.querySelectorAll('.open-booking-form-date');
  let bookingForm = document.querySelector('#booking-form .container-calendar-visitor__date-section');

  //if the date section doesn't exist, it must be a ticketing system experience (so open the visitors section instead)
  if(!bookingForm){
    bookingForm = document.querySelector('#booking-form .container-calendar-visitor__visitor-section');
  }

  if(openBookingFormDateButtons && bookingForm){
    openBookingFormDateButtons.forEach(button => {
      button.addEventListener('click', () => {
        //first close any drawer on the page
        Drawer.closeAllDrawers();

        //then open the booking form date
        //add a little delay to make sure any drawer is closed & scroll animation is done
        window.setTimeout(() => {
          bookingForm.dispatchEvent(new Event('click'));
        }, 500);
      });
    });
  }
}

export { initOpenBookingFormDate }
